import * as Migration from 'shared/migration/migration';
import { Conversion } from 'shared/migration/migration';

type LegacyAction = Record<string, any>;

const conversions: Conversion<LegacyAction>[] = [
  { version: '1', rules: [{ isSuitable: () => true, migrateUp: v0tov1 }] },
];

export const CURRENT_VERSION = '1';

export function migrateToTheLatest(actions: LegacyAction[]) {
  return Migration.migrateToTheLatest(actions, conversions);
}

function v0tov1(action: LegacyAction): LegacyAction {
  action.schedule ??= {};
  action.schedule.notify ??= {};

  const { notify } = action.schedule;
  notify.enableEventsLog ??= true;
  notify.slack ??= {
    channel: '',
    onError: true,
    onSuccess: false,
  };
  return action;
}
